const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
module.exports = {
  apiBaseUrl: apiBaseUrl,
};
